import { IApiResult } from "../interfaces/IGeneral";
import { GUIDType } from "../interfaces/types";
import ApiBase from "./ApiBase";
import { animalWaitingRoomUrl } from "./apiEndpoints";

class AnimalWaitingRoomApi extends ApiBase {
    emptyProducerWaitingRoom = (farmId: GUIDType) => {
        return this.delete<{}>(`${animalWaitingRoomUrl}/${farmId}`, {});
    };
}

export default new AnimalWaitingRoomApi()